import { gql } from '@apollo/client';

export const GetSummaryLapsGenderStudentsByRegionResultsQuery = gql`
    query GetSummaryLapsGenderStudentsByRegionResults($filter: SummaryResultsFilter) {
        getSummaryLapsGenderStudentsByRegionResults(filter: $filter) {
            regionName
            summary
            sections {
                gender
                summary
                items {
                    age
                    count
                }
            }
        }
    }
`;
